export const disputeManagementConstants = {

    //dispute messages
    //get
    GET_DISPUTEMESSAGE_LIST_REQUEST: "GET_DISPUTEMESSAGE_LIST_REQUEST",
    GET_DISPUTEMESSAGE_LIST_SUCCESS: "GET_DISPUTEMESSAGE_LIST_SUCCESS",
    GET_DISPUTEMESSAGE_LIST_FAILURE: "GET_DISPUTEMESSAGE_LIST_FAILURE",


    //update status
    UPDATE_DISPUTEMESSAGE_STATUS_REQUEST: "GET_DISPUTEMESSAGE_STATUS_REQUEST",
    UPDATE_DISPUTEMESSAGE_STATUS_SUCCESS: "GET_DISPUTEMESSAGE_STATUS_SUCCESS",
    UPDATE_DISPUTEMESSAGE_STATUS_FAILURE: "GET_DISPUTEMESSAGE_STATUS_FAILURE",


    //dispute  category 
    //get
    GET_DISPUTECATEGORY_LIST_REQUEST: "GET_DISPUTECATEGORY_LIST_REQUEST",
    GET_DISPUTECATEGORY_LIST_SUCCESS: "GET_DISPUTECATEGORY_LIST_SUCCESS",
    GET_DISPUTECATEGORY_LIST_FAILURE: "GET_DISPUTECATEGORY_LIST_FAILURE",


    //update status
    UPDATE_DISPUTECATEGORY_STATUS_REQUEST: "GET_DISPUTECATEGORY_STATUS_REQUEST",
    UPDATE_DISPUTECATEGORY_STATUS_SUCCESS: "GET_DISPUTECATEGORY_STATUS_SUCCESS",
    UPDATE_DISPUTECATEGORY_STATUS_FAILURE: "GET__DISPUTECATEGORY_STATUS_FAILURE",

    GET_ADVERTISEMENT_LIST_REQUEST: "GET_ADVERTISEMENT_LIST_REQUEST",
    GET_ADVERTISEMENT_LIST_SUCCESS: "GET_ADVERTISEMENT_LIST_SUCCESS",
    GET_ADVERTISEMENT_LIST_FAILURE: "GET_ADVERTISEMENT_LIST_FAILURE",

    //get terms and tag
    GET_TERMS_LIST_REQUEST: "GET_TERMS_LIST_REQUEST",
    GET_TERMS_LIST_SUCCESS: "GET_TERMS_LIST_SUCCESS",
    GET_TERMS_LIST_FAILURE: "GET_TERMS_LIST_FAILURE",




    //update status
    UPDATE_TERMS_STATUS_REQUEST: "GET_TERMS_STATUS_REQUEST",
    UPDATE_TERMS_STATUS_SUCCESS: "GET_TERMS_STATUS_SUCCESS",
    UPDATE_TERMS_STATUS_FAILURE: "GET_TERMS_STATUS_FAILURE",


    //get
    GET_DISPUTERAISEDLIST_REQUEST: "GET_DISPUTERAISEDLIST_REQUEST",
    GET_DISPUTERAISEDLIST_SUCCESS: "GET_DISPUTERAISEDLIST_SUCCESS",
    GET_DISPUTERAISEDLIST_FAILURE: "GET_DISPUTERAISEDLIST_FAILURE",


    //update
    UPDATE_DISPUTEAPPEAL_REQUEST: "UPDATE_DISPUTEAPPEAL_REQUEST",
    UPDATE_DISPUTEAPPEAL_SUCCESS: "UPDATE_DISPUTEAPPEAL_SUCCESS",
    UPDATE_DISPUTEAPPEAL_FAILURE: "UPDATE_DISPUTEAPPEAL_FAILURE",


    //getdetails
    GET_COINTRADE_DETAILS_REQUEST: "GET_COINTRADE_DETAILS_REQUEST",
    GET_COINTRADE_DETAILS_SUCCESS: "GET_COINTRADE_DETAILS_SUCCESS",
    GET_COINTRADE_DETAILS_FAILURE: "GET_COINTRADE_DETAILS_FAILURE",

    //add
    CREATE_COINTRADE_LIST_REQUEST: "CREATE_COINTRADE_LIST_REQUEST",
    CREATE_COINTRADE_LIST_SUCCESS: "CREATE_COINTRADE_LIST_SUCCESS",
    CREATE_COINTRADE_LIST_FAILURE: "CREATE_COINTRADE_LIST_FAILURE",

    //update
    UPDATE_COINTRADE_REQUEST: "UPDATE_COINTRADE_REQUEST",
    UPDATE_COINTRADE_SUCCESS: "UPDATE_COINTRADE_SUCCESS",
    UPDATE_COINTRADE_FAILURE: "UPDATE_COINTRADE_FAILURE",
    //delete
    DELETE_COINTRADE_REQUEST: "DELETE_COINTRADE_REQUEST",
    DELETE_COINTRADE_SUCCESS: "DELETE_COINTRADE_SUCCESS",
    DELETE_COINTRADE_FAILURE: "DELETE_COINTRADE_FAILURE",

    UPDATE_COINTRADE_STATUS_REQUEST: "UPDATE_COINTRADE_STATUS_REQUEST",
    UPDATE_COINTRADE_STATUS_SUCCESS: "UPDATE_COINTRADE_STATUS_SUCCESS",
    UPDATE_COINTRADE_STATUS_FAILURE: "UPDATE_COINTRADE_STATUS_FAILURE",

    //getdetails
    GET_COINLIST_DETAILS_REQUEST: "GET_COINLIST_DETAILS_REQUEST",
    GET_COINLIST_DETAILS_SUCCESS: "GET_COINLIST_DETAILS_SUCCESS",
    GET_COINLIST_DETAILS_FAILURE: "GET_COINLIST_DETAILS_FAILURE",

    GET_BANK_DETAILS_REQUEST: "GET_BANK_DETAILS_REQUEST",
    GET_BANK_DETAILS_SUCCESS: "GET_BANK_DETAILS_SUCCESS",
    GET_BANK_DETAILS_FAILURE: "GET_BANK_DETAILS_FAILURE",


    // transaction dispute

    GET_TRANSACTIONDISPUTE_LIST_REQUEST: "GET_TRANSACTIONDISPUTE_LIST_REQUEST",
    GET_TRANSACTIONDISPUTE_LIST_SUCCESS: "GET_TRANSACTIONDISPUTE_LIST_SUCCESS",
    GET_TRANSACTIONDISPUTE_LIST_FAILURE: "GET_TRANSACTIONDISPUTE_LIST_FAILURE",

    UPDATE_TRANSACTIONDISPUTE_REQUEST: "UPDATE_TRANSACTIONDISPUTE_REQUEST",
    UPDATE_TRANSACTIONDISPUTE_SUCCESS: "UPDATE_TRANSACTIONDISPUTE_SUCCESS",
    UPDATE_TRANSACTIONDISPUTE_FAILURE: "UPDATE_TRANSACTIONDISPUTE_FAILURE",

    GET_DISPUTESTATS_REQUEST: "GET_DISPUTESTATS_REQUEST",
    GET_DISPUTESTATS_SUCCESS: "GET_DISPUTESTATS_SUCCESS",
    GET_DISPUTESTATS_FAILURE: "GET_DISPUTESTATS_FAILURE",


    UPDATE_TERMS_REQUEST: "UPDATE_TERMS_REQUEST",
    UPDATE_TERMS_SUCCESS: "UPDATE_TERMS_SUCCESS",
    UPDATE_TERMS_FAILURE: "UPDATE_TERMS_FAILURE",


}